export default __webpack_public_path__ + "static/media/pipe.58ea9600.png";